import React, {useCallback, useEffect, useReducer} from 'react';
import {JanusInstance, JanusStatus, MediaDeviceStatus, PluginStatus} from "../../../constants/Janus";
import Janus from "../../../utils/Janus/janus";
import {initVideoPubState, videoRoomPubReducer} from "../../../store/reducers/VideoRoom/Publisher";
import {
    attachVRoomPub,
    joinVideoRoom,
    publishOwnFeed,
    publishScreen, publishStreamFeed,
    unpublishOwnFeed
} from "../../../utils/Janus/VideoRoom/vpublisher";
import {VideoPubEvent} from "../../../constants/Janus/VideoRoom/Publisher";
import {BITRATE} from "../../../pages/videoCall/VideoConference/utils/janusUtils";

// import {joinVideoRoom, publishOwnFeed} from "../../utils/Janus/MVideoRoom/publisher";

interface useVRoomPubProps {
    janusInstance: JanusInstance
    janusStatus: JanusStatus
    JanusModule?: any
    onLocalStream: (janusModule: any, videoPlugin: any, stream: any) => void
    onSuccess?: () => void
    onJoined?: () => void
    onCleanup?: () => void
}

export const useVRoomPub = ({
                         janusInstance,
                         janusStatus,
                         JanusModule = Janus,
                         onLocalStream,
    onSuccess,
    onJoined,
                                onCleanup
                     }: useVRoomPubProps) => {
    const [videoPub, pubDispatch] = useReducer(videoRoomPubReducer, initVideoPubState);

    const clearData = () => {
        // localStream = null;
    }

    useEffect(() => {
        const videoId: string = "videoroom-" + JanusModule.randomString(12);
        pubDispatch({type: VideoPubEvent.SET, payload: {key: "opaqueId", value: videoId}});

        return () => {
            clearData();
        }
    }, [])

    // useEffect(() => {
    //     // console.log("videoPub.mediaStatus", videoPub.mediaStatus)
    //     if (videoPub.mediaStatus !== MediaDeviceStatus.Unpublished) return
    //     unpublish();
    // }, [videoPub.mediaStatus])

    // useEffect(() => {
    //     console.log("videoPub.webrtcState", videoPub.webrtcState)
    // }, [videoPub.webrtcState])

    const publishOwnFeedCallback = (eventType: string, data: any) => {
        if (eventType === "success") {
            // dispatch({type: VideoEventType.VIDEO_SUCCESS});
            pubDispatch({type: VideoPubEvent.SET, payload: {key: "publish", value: true}});
        } else if (eventType === "error") {
            pubDispatch({type: VideoPubEvent.SET, payload: {key: "publish", value: false}});
            // dispatch({type: VideoEventType.VIDEO_ERROR, payload: {errorEvent: data, errorMsg: data.message}});
        }
    }

    const publishScreenCallback = (eventType: string, pubPlugin: any, data: any) => {
        if (eventType === "success") {
            // dispatch({type: VideoEventType.VIDEO_SUCCESS});
            pubDispatch({type: VideoPubEvent.SET, payload: {key: "publish", value: true}});
        } else if (eventType === "error") {
            pubDispatch({type: VideoPubEvent.SET, payload: {key: "publish", value: false}});

            let leave = { request: "leave" };
            console.log("[Leave share screen request]: ", leave);

            try {
                pubPlugin.send({ message: leave,
                    success: function() {
                        pubPlugin.hangup();
                        try {
                            pubPlugin.detach();
                        } catch (e) {

                        }
                    }
                });
                // if (reason !== 'cancel') {
                //     openNotificationWithIcon('warning', 'Screen sharing is switched.', 'Your screen sharing has been canceled.');
                // }
            } catch (e) {
                console.log("Stop share screen error", e);
            }
            // dispatch({type: VideoEventType.VIDEO_ERROR, payload: {errorEvent: data, errorMsg: data.message}});
        }
    }


    const clear = () => {
        pubDispatch({type: VideoPubEvent.CLEAR});
    }

    const joinRoom = useCallback((room: number, display: string) => {
        joinVideoRoom(videoPub.videoPlugin, room, display);
    }, [videoPub.videoPlugin])

    const publishCamera = useCallback((useAudio = false) => {
        // dispatch({type: VideoEventType.VIDEO_PUBLISHING});
        publishOwnFeed(videoPub.videoPlugin, useAudio, false, publishOwnFeedCallback);
    }, [videoPub.videoPlugin])

    const publishStream = useCallback((stream: any) => {
        publishStreamFeed(JanusModule, videoPub.videoPlugin, stream, true, false, false, BITRATE, false, publishOwnFeedCallback);
    }, [videoPub.videoPlugin])

    const shareScreen = useCallback(() => {
        publishScreen(JanusModule, videoPub.videoPlugin ,publishScreenCallback);
    }, [videoPub.videoPlugin])

    const unpublish = useCallback(() => {
        unpublishOwnFeed(videoPub.videoPlugin);
    }, [videoPub.videoPlugin])

    const togglePublish = useCallback(() => {
        if (videoPub.publish) {
            unpublish();
        } else {
            publishCamera();
        }
    }, [videoPub.videoPlugin, videoPub.publish])


    const attachPubPlugin = useCallback(() => {
        pubDispatch({type: VideoPubEvent.SET, payload: {key: "pluginStatus", value: PluginStatus.Attaching}});
        attachVRoomPub(JanusModule, janusInstance, videoPub.opaqueId,undefined, undefined, videoPub.username, true,
            (videoPlugin: any, eventType: VideoPubEvent, payload: any) => {
                pubDispatch({type: VideoPubEvent.SET, payload: {key: "videoPlugin", value: videoPlugin}});
                switch (eventType) {
                    case VideoPubEvent.SUCCESS: {
                        pubDispatch({ type: VideoPubEvent.SUCCESS, payload });
                        onSuccess?.();
                        break;
                    }
                    case VideoPubEvent.ERROR: {
                        pubDispatch({ type: VideoPubEvent.ERROR, payload });
                        break;
                    }
                    case VideoPubEvent.CONSENT_DIALOG: {
                        pubDispatch({ type: VideoPubEvent.CONSENT_DIALOG, payload });
                        break;
                    }
                    case VideoPubEvent.ICE_STATE: {
                        pubDispatch({ type: VideoPubEvent.ICE_STATE, payload });
                        break;
                    }
                    case VideoPubEvent.MEDIA_STATE: {
                        pubDispatch({ type: VideoPubEvent.MEDIA_STATE, payload });
                        break;
                    }
                    case VideoPubEvent.WEBRTC_STATE: {
                        pubDispatch({ type: VideoPubEvent.WEBRTC_STATE, payload });
                        break;
                    }
                    case VideoPubEvent.JOINED: {
                        pubDispatch({ type: VideoPubEvent.JOINED, payload });
                        onJoined?.();
                        break;
                    }
                    case VideoPubEvent.DESTROYED: {
                        pubDispatch({ type: VideoPubEvent.DESTROYED });
                        break;
                    }
                    case VideoPubEvent.PUBLISHERS: {
                        pubDispatch({ type: VideoPubEvent.PUBLISHERS, payload });
                        break;
                    }
                    case VideoPubEvent.LEAVING: {
                        pubDispatch({ type: VideoPubEvent.LEAVING, payload });
                        break;
                    }
                    case VideoPubEvent.UNPUBLISHED: {
                        if (payload === 'ok') {
                            // That's us
                            videoPlugin.hangup();
                            // return;
                            pubDispatch({type: VideoPubEvent.SET, payload: {key: "publish", value: false}});
                            break;
                        }
                        // pubDispatch({ type: VideoPubEvent.UNPUBLISHED, payload });
                        break;
                    }
                    case VideoPubEvent.ERROR_EVENT: {
                        pubDispatch({ type: VideoPubEvent.ERROR_EVENT, payload });
                        break;
                    }
                    case VideoPubEvent.ON_LOCAL_STREAM: {
                        pubDispatch({ type: VideoPubEvent.ON_LOCAL_STREAM, payload });
                        onLocalStream(JanusModule, videoPlugin, payload);
                        break;
                    }
                    case VideoPubEvent.ON_CLEAN_UP: {
                        pubDispatch({ type: VideoPubEvent.ON_CLEAN_UP });
                        onCleanup?.();
                        break;
                    }
                    default: {
                        break;
                    }
                }
            }
        );
    }, [JanusModule, janusInstance, videoPub.opaqueId])

    const publisherLeft = useCallback((rfid: number) => {
        pubDispatch({ type: VideoPubEvent.PUBLISHER_LEFT, payload: rfid });
    }, [videoPub.publishers])

    return {
        janusModule: JanusModule,
        janusInstance: janusInstance,
        ...videoPub,
        attachPubPlugin,
        // attachMSubscriberPlugin,
        publisherLeft,
        joinRoom,
        publishCamera,
        publishStream,
        shareScreen,
        unpublish,
        togglePublish,
        clear,
    }

}